import './application.css'
import { router } from '@inertiajs/core'
import { createInertiaApp } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'

void createInertiaApp({
  strictMode: true,
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true })
    const page = pages[`../pages/${name}.tsx`] as any
    if (page == null) throw new Error(`ページコンポーネントが見つかりません: ${name}`)
    return page.default ?? page
  },
  setup ({ el, App, props }) {
    if (el == null) return
    createRoot(el).render(createElement(App, props))
  }
})

const measurementId = document.querySelector('meta[name="ga-measurement-id"]')?.getAttribute('content')

router.on('navigate', (event) => {
  if (typeof window.gtag !== 'undefined' && measurementId != null) {
    window.gtag('config', measurementId, {
      page_path: window.location.pathname
    });
  }
})
